module.exports = __webpack_public_path__ + "img/res-6.e7671fe8.png";